export default __webpack_public_path__ + "static/media/mascote-crop.a1e65013.png";